import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CustomDialogComponent } from './custom-dialog.component';
import { DialogModule } from '@angular/cdk/dialog';

@NgModule({
  declarations: [CustomDialogComponent],
  exports: [CustomDialogComponent],
  imports: [CommonModule, DialogModule],
})
export class CustomDialogModule {}
